import React, { useState } from 'react';
import { Text, Label } from '@leverege/ui-elements';
import RecovrSales from '../../util/RecovrSales';
import S from './ChangeVehicleOwnership.css';
import DefaultDialog from '../../components/DefaultDialog';
import Loading from '../../components/Loading';
import UserForm, { useUserFormErrors } from '../../views/salesFlow/components/UserForm';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function ChangeVehicleOwnershipDialog(props) {
  const {
    show,
    onClose,
    actions,
    sale,
    customer,
    customerEmail,
    parentPath
  } = props;
  const [loading, setLoading] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [values, setValues] = useState({
    name: customer?.name,
    phone: customer?.phoneNumber,
    address: customer?.addressFields
  });
  const {
    errors,
    setValidateOnDataChange,
    getValidationErrors
  } = useUserFormErrors({
    data: values
  });
  const onChange = ({
    data,
    value
  }) => {
    setValues(prevValues => ({
      ...prevValues,
      [data]: value
    }));
  };
  const onInvite = async () => {
    const validationErrors = getValidationErrors();
    if (Object.keys(validationErrors).length > 0) {
      setValidateOnDataChange(true);
      return;
    }
    setConfirm(true);
  };
  const onConfirm = async () => {
    if (loading) {
      return;
    }
    setLoading(true);
    const {
      location: streetAddress,
      ...addressFields
    } = values.address;
    await RecovrSales.changeVehicleOwnership({
      saleId: sale?.id,
      locationId: sale?.data?.data?.[parentPath]?.id,
      actions,
      customer,
      newCustomer: {
        email: values.email,
        name: values.name,
        phoneNumber: values.phone,
        streetAddress,
        addressFields
      }
    });
    setLoading(false);
    onClose();
  };
  const dialogTitle = confirm ? 'Confirm Change of Vehicle Ownership' : 'Change Vehicle Ownership';
  const userDetails = {
    'New User Email': values?.email,
    'Full Name': values?.name,
    'Phone Number': values?.phone,
    Address: values?.address?.location
  };
  return /*#__PURE__*/_jsxs(DefaultDialog, {
    show: show,
    onClose: onClose,
    className: S.dialog,
    title: dialogTitle,
    titleIcon: "https://storage.googleapis.com/recovr-ui-assets/menu-icons/sales.png",
    submitText: confirm ? 'Confirm Change' : 'Invite New User',
    onSubmit: confirm ? onConfirm : onInvite,
    submitDisabled: loading,
    cancelDisabled: loading,
    children: [!confirm && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Text, {
        className: S.warning,
        variant: "caption",
        children: "Adding a new account email below will remove all permissions associated with the current account email."
      }), /*#__PURE__*/_jsx(Label, {
        variant: "inputTitle",
        children: "Current Account Email"
      }), /*#__PURE__*/_jsx(Text, {
        className: S.email,
        variant: "bodySmall",
        children: customerEmail
      }), /*#__PURE__*/_jsx(UserForm, {
        onChange: onChange,
        data: values,
        errors: errors
      })]
    }), confirm && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Text, {
        className: S.topText,
        variant: "body",
        children: "Clicking \u201CConfirm Change\u201D will remove all permissions associated with the current account email and will send an invitation email to the new account email."
      }), /*#__PURE__*/_jsx(Text, {
        variant: "body",
        children: "Current Account Email (Access Will Be Removed)"
      }), /*#__PURE__*/_jsx(Text, {
        className: S.emailConfirm,
        variant: "bodyBold",
        children: customerEmail
      }), /*#__PURE__*/_jsx("div", {
        className: S.info,
        children: Object.entries(userDetails).map(([field, value]) => {
          return /*#__PURE__*/_jsxs(React.Fragment, {
            children: [/*#__PURE__*/_jsx(Text, {
              variant: "body",
              children: field
            }), /*#__PURE__*/_jsx(Text, {
              className: S.emailConfirm,
              variant: "bodyBold",
              children: value
            })]
          }, `${field}-${value}`);
        })
      })]
    }), /*#__PURE__*/_jsx(Loading, {
      loading: loading
    })]
  });
}
export default ChangeVehicleOwnershipDialog;